import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "precision"];
import React from 'react';
import TimePanel from './Panel';
import "./style/time-picker.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TimePickerTime(props) {
  var {
      prefixCls = 'w-timepicker',
      className,
      precision = 'second'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: [prefixCls, className].filter(Boolean).join(' ').trim(),
    children: [/^(second|minute|hour)$/.test(precision) && /*#__PURE__*/_jsx(TimePanel, _extends({
      type: "Hours",
      count: 24
    }, other)), /^(second|minute)$/.test(precision) && /*#__PURE__*/_jsx(TimePanel, _extends({
      type: "Minutes",
      count: 60
    }, other)), /^(second)$/.test(precision) && /*#__PURE__*/_jsx(TimePanel, _extends({
      type: "Seconds",
      count: 60
    }, other))]
  });
}